import { useCallback, useContext } from 'react';
import LeftNavigationContext from '../LeftNavigationContext.js';

type UseOpenableOnClickHandlerProps = {
  id: string;
  onExpand: React.MouseEventHandler & React.KeyboardEventHandler;
  onOpen: React.MouseEventHandler & React.KeyboardEventHandler;
  onClose: React.MouseEventHandler & React.KeyboardEventHandler;
  opened: boolean;
};

export const useOpenableOnClickHandler = ({
  id,
  opened,
  onExpand,
  onOpen,
  onClose,
}: UseOpenableOnClickHandlerProps): ((e: React.MouseEvent<HTMLElement>) => void) => {
  const {
    leftNavProps: { expanded },
    setSelectedItem,
  } = useContext(LeftNavigationContext);

  const handleOnExpand: React.MouseEventHandler = useCallback(
    (e) => {
      onExpand(e);
      setSelectedItem(id);
    },
    [id, onExpand, setSelectedItem],
  );

  const handleOnOpen: React.MouseEventHandler = useCallback(
    (e) => {
      onOpen(e);
      setSelectedItem(id);
    },
    [id, onOpen, setSelectedItem],
  );

  const handleOnClose: React.MouseEventHandler = useCallback(
    (e) => {
      onClose(e);
      setSelectedItem(id);
    },
    [id, onClose, setSelectedItem],
  );

  const handleOnClick: React.MouseEventHandler = useCallback(
    (e) => {
      if (!expanded) handleOnExpand(e);
      else if (!opened) handleOnOpen(e);
      else handleOnClose(e);
    },
    [expanded, opened, handleOnExpand, handleOnOpen, handleOnClose],
  );

  return handleOnClick;
};
